<template>

    <!-- TW Snippet Start v2.0+ -->
    <div class="relative bg-white">
        <div class="max-w-7xl mx-auto">
            <div class="relative z-10 pb-8 bg-white lg:max-w-2xl lg:w-full">

                <div class="relative pt-6 px-4 sm:px-6 lg:px-8">
                    <nav class="relative flex items-center justify-between sm:h-10 lg:justify-start" aria-label="Global">
                        <div class="flex items-center grow flex-shrink-0 lg:grow-0">
                            <div class="flex items-center justify-between w-full md:w-auto">
                                <a href="/">
                                    <span class="sr-only">DSchránka</span>

                                    <LogoImg class="w-8 h-auto sm:w-10" />
                                </a>
                                <div class="-mr-2 flex items-center md:hidden">
                                    <button @click="menuShow = true" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" id="main-menu" aria-haspopup="true">
                                        <span class="sr-only">Zobrazit hlavní menu</span>
                                        <!-- Heroicon name: menu -->
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="hidden md:block md:ml-10 md:pr-4 md:space-x-8">
                            <a href="/#product" class="font-medium text-gray-500 hover:text-gray-900">Domů</a>

                            <a href="/#features" class="font-medium text-gray-500 hover:text-gray-900">Funkce</a>

                            <a href="/#pricing" class="font-medium text-gray-500 hover:text-gray-900">Ceník</a>

                            <a :href="route('faq')" class="font-medium text-gray-500 hover:text-gray-900">FAQ</a>

                            <a :href="route('app')" class="bg-indigo-100 nline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-indigo-600 bg-white hover:bg-gray-50">
                                Přihlášení
                            </a>

                        </div>
                    </nav>
                </div>

                <transition
                    enter-active-class="duration-150 ease-out"
                    enter-from-class="opacity-0 scale-95"
                    enter-to-class="opacity-100 scale-100"
                    leave-active-class="duration-100 ease-in"
                    leave-from-class="opacity-100 scale-100"
                    leave-to-class="opacity-0 scale-95"
                >
                    <div v-show="menuShow" id="heroMenu" class="opacity-0 scale-95 absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden">
                        <div class="rounded-lg shadow-md bg-white ring-1 ring-black ring-opacity-5">
                            <div class="px-5 pt-4 flex items-center justify-between">
                                <div>
                                    <a href="/">
                                        <LogoImg class="w-8 h-auto sm:w-10" />
                                    </a>
                                </div>
                                <div class="-mr-2">
                                    <button @click="menuShow = false" type="button" class="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                                        <span class="sr-only">Zavřít menu</span>
                                        <!-- Heroicon name: x -->
                                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div role="menu" aria-orientation="vertical" aria-labelledby="main-menu">
                                <div class="px-2 pt-2 pb-3 space-y-1" role="none">
                                    <a href="/#product" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Domů</a>

                                    <a href="/#features" class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Funkce</a>

                                    <a href="/#pricing"  class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">Ceník</a>

                                    <a :href="route('faq')"  class="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50" role="menuitem">FAQ</a>


                                </div>
                                <div role="none">
                                    <a :href="route('app')" class="block w-full px-5 py-3 text-center font-medium text-indigo-600 bg-gray-50 hover:bg-gray-100" role="menuitem">
                                        Do aplikace
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

            </div>
        </div>
    </div>



    <div>
        <!-- TW Snippet Start v2.0+ -->
        <div class="">
            <div class="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
                <div class="max-w-3xl mx-auto divide-y-2 divide-gray-200">
                    <h2 class="text-center text-3xl font-extrabold text-gray-900 sm:text-4xl">
                        Často kladené otázky
                    </h2>
                    <p class="border-none text-center text-gray-500 text-base">
                        Nenešli jste odpověď? Zeptejte se na
                        <a class="underline" href="mailto:info@dschranka.cz" target="_blank">info@dschranka.cz</a>.
                    </p>
                    <dl class="mt-6 space-y-3 divide-y divide-gray-200">
                        <!--suppress EqualityComparisonWithCoercionJS -->
                        <div :id="'q' + question.id" v-for="question in questions" class="py-3 px-2 rounded-md">
                            <dt class="text-lg">
                                <!-- Expand/collapse question button -->
                                <button @click="question.open = !question.open" type="button" class="text-left w-full flex justify-between items-start text-gray-400" aria-controls="faq-0" aria-expanded="false">
                                    <span class="font-medium text-gray-900 font-bold">
                                      {{ question.question }}
                                    </span>
                                    <span class="ml-6 h-7 flex items-center">
                                      <svg :class="question.open ? '-rotate-180' : 'rotate-0' " class="h-6 w-6 transform" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                                      </svg>
                                    </span>
                                </button>
                            </dt>
                            <FAQItemAnswer v-if="question.open" :question="question"></FAQItemAnswer>
                        </div>

                        <!-- More questions... -->
                    </dl>
                </div>
            </div>
        </div>
    </div>

    <Footer></Footer>
</template>

<script>
import Footer from "@/Pages/Presentation/Footer";
import FAQItemAnswer from "../Components/FAQItemAnswer";
import LogoImg from "../Components/LogoImg";
export default {
    name: "FAQ",
    components: {
        LogoImg,
        FAQItemAnswer,
        Footer
    },
    mounted(){
        if(this.$page.props.id){
            console.log('id');
            for(let i = 0; i < this.questions.length; i++){
                // noinspection EqualityComparisonWithCoercionJS
                if(this.questions[i].id == this.$page.props.id)
                    this.questions[i].open = true;
            }
        }
    },
    data(){
        return {
            questions: this.$page.props.questions,

            menuShow: false,
        }
    }
}
</script>

<style scoped>

</style>
